import { AlertCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useTriggerBackfillMutation } from '@/lib/query-options';

interface TruncationBannerProps {
  businessId: number;
  isAdmin: boolean;
  /** ISO timestamp from business.backfill_truncated_at. */
  truncatedAt: string;
}

export function TruncationBanner({
  businessId,
  isAdmin,
  truncatedAt,
}: TruncationBannerProps) {
  const backfill = useTriggerBackfillMutation(businessId);

  const handleRetry = () => backfill.mutate();

  const dateText = new Date(truncatedAt).toLocaleDateString();

  return (
    <div
      className="flex items-start gap-3 border-l-4 border-[#FDE68A] bg-[#FEF3C7] px-4 py-3"
      role="status"
      data-testid="truncation-banner"
    >
      <AlertCircle className="mt-0.5 h-5 w-5 text-[#A16207]" />
      <div className="flex-1 text-sm text-[#A16207]">
        <span className="font-medium">Some locations weren't imported.</span>{' '}
        Backfill on {dateText} hit the 50-row limit. Review your campaign
        history or add the missing locations manually below.
      </div>
      {isAdmin && (
        <Button
          size="sm"
          variant="outline"
          onClick={handleRetry}
          disabled={backfill.isPending}
        >
          {backfill.isPending ? 'Running...' : 'Run again'}
        </Button>
      )}
    </div>
  );
}
